<template>
  <div id="left-column">
    <div class="label mt-4">
      Ref: {{ propertyData?.id }}
    </div>
    <HH2
      v-if="propertyData?.comments?.[0]?.title"
      class="mb-5 mt-4"
      v-html="propertyData?.comments?.[0]?.title"
    />

    <AdsMobilePriceAndInfo :property-data="propertyData" />

    <div class="row resume">
      <div class="col-auto">
        <div class="mb-2">
          Type de bien
        </div>
        <div class="d-flex align-items-center">
          <SvgHouseOutlined class="icon mr-2" /> <span class="resume__label">{{ type }}</span>
        </div>
      </div>
      <div class="area col-auto">
        <div class="mb-2">
          Surface Carrez
        </div>
        <div class="d-flex align-items-center">
          <SvgPlan class="icon mr-2" /> <span class="resume__label">{{ propertyData?.area?.value || propertyData?.area?.total }} m²</span>
        </div>
      </div>
      <div class="rooms col-auto">
        <div class="mb-2">
          {{ propertyData?.rooms > 1 ? 'Pièces' : 'Pièce' }}
        </div>
        <div class="d-flex align-items-center">
          <SvgDoor class="icon mr-2" /> <span class="resume__label">{{ propertyData?.rooms }}</span>
        </div>
      </div>
    </div>

    <VDivider
      :thickness="2"
      color="#CECFD6"
      class="my-3"
    />

    <div id="description-container">
      <LazyHH4 class="mt-5 mb-4">
        Description
      </LazyHH4>
      <p v-html="transformHTML(propertyData?.comments?.[0]?.comment)" />
    </div>

    <AdsVideoContainer
      v-if="propertyData?.medias?.length > 0"
      :medias="propertyData?.medias"
    />
    <AdsPropertyDetails :property-data="propertyData" />
    <AdsSurfaces :areas="propertyData?.areas" />
    <AdsPrestations
      v-if="propertyData?.services?.length"
      :services="propertyData?.services"
    />
    <AdsEnergy :regulations="propertyData?.regulations" />
    <AdsLegalInformations :regulations="propertyData?.regulations" />
    <AdsProximities
      v-if="propertyData?.proximities.length"
      :proximities="propertyData?.proximities"
    />
    <AdsLocation
      :latitude="propertyData?.latitude"
      :longitude="propertyData?.longitude"
    />
  </div>
</template>

<script lang="ts" setup>
import upperFirst from 'lodash/upperFirst'
import type { SvgPlan } from '#build/components'

const props = defineProps<{
  propertyData?: Record<string, any>
}>()

const type = computed(() => {
  return upperFirst(props.propertyData?.type)
})

function transformHTML (str: string | null | undefined) {
  return str?.replace(/(\r\n|\r|\n)/g, '<br />') || ''
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}

.title {
  font-size: 2.875rem;
  font-weight: bold;
  margin-bottom: 1em;
  line-height: 1;
}

#subtitle {
  font-size: 34px;
  font-weight: normal;
  margin-bottom: 1em;
  line-height: 1.25;
}

.resume {
  .label {
    font-size: 16px;
  }

  .bold {
    font-size: 26px;
  }

  .ref .label {
    font-size: 12px;
    right: 0;
  }
}

#description-container {
  margin-bottom: 30px;
}

@media (width <= 768px) {
  #title,
  #subtitle {
    font-size: 24px;
  }

  .resume .label {
    font-size: 14px;
  }

  .resume .bold {
    font-size: 20px;
  }

  .type {
    padding-left: 0;
  }

  .area {
    padding-left: 20px;
  }

  .rooms {
    padding-left: 25px;
  }
}

.icon {
  width: fit-content;
  height: 20px;
  display: inline-block;
}

.resume__label {
  color: $night-blue;
  font-size: 1.25rem;
  font-weight: 500;
}
</style>
